import BodyText from "components/Typography/BodyText"
import React, { memo } from "react"
import styled from "styled-components"

const FooterContent = styled.div`
  align-items: flex-end;
  padding: 0px 16px 12px 16px;
  height: 64px;
  width: 100%;
  display: flex;
  width: 100%;
`

const LearnMoreContainer = styled.div`
  background-color: transparent;
  border-radius: 8px;
  padding: 4px 8px;
  border: 1px solid ${(props) => props.theme.palette.white};
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  margin-left: auto;
`

const FooterContainer = styled.div`
  justify-content: flex-end;
  align-items: flex-end;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
  height: 62px;
  display: flex;
  width: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);
  z-index: 1;
`

const BannerCardFooter: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <LearnMoreContainer>
          <BodyText size="medium" weight="semi-bold" color="white">
            Saiba Mais
          </BodyText>
        </LearnMoreContainer>
      </FooterContent>
    </FooterContainer>
  )
}

export default memo(BannerCardFooter)
